module.exports = __webpack_public_path__ + "img/iconUser.33912c66.svg";